<template>
	<div>
		<DialogBody>
			<div class="dialog-date-picker d-flex align-center justify-center">
				<DateRangePicker
					:model-value="dates"
					inline
					@update:model-value="(e) => (newDates = e)"
					:display-two-months="!isXS"
				/>
			</div>
		</DialogBody>
		<DialogActions
			:accept-action="{ text: $t('web.itinerary.date_modal.add_button') }"
			:cancel-action="{ text: $t('web.itinerary.date_modal.reset_button') }"
			:disable-accept="!newDates"
			@accept="$emit('accept', newDates)"
			@cancel="$emit('cancel')"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue'
	interface Props {
		dates?: Date[]
		isXS: boolean
	}
	const props = defineProps<Props>()
	defineEmits(['accept', 'cancel'])

	const newDates = ref<Date[] | undefined>(props.dates)
</script>

<style lang="scss">
	.dialog-date-picker {
		.dp__menu {
			width: 100%;
			border: none;
			display: block;
		}
		.dp__menu_inner {
			width: 100%;
		}
		.dp__range_start,
		.dp__range_end {
			background-color: var(--color-primary-25) !important;
			z-index: 1;
			position: relative;
			border-radius: unset;
			&::before {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: var(--color-primary-700) !important;
				top: 50%;
				left: 50%;
				border-radius: 50%;
				transform: translate(-50%, -50%);
				z-index: -1;
			}
		}
		.dp__range_between {
			background-color: var(--color-primary-25) !important;
		}
		.dp__calendar_item {
			font-weight: 600;
			font-size: 14px;
			line-height: 18px;
			letter-spacing: -0.24px;
			text-align: center;
			vertical-align: middle;
		}
		.dp__calendar_item,
		.dp__range_between,
		.dp__calendar_header_item,
		.dp__month_year_select {
			color: var(--color-neutral-900) !important;
		}
		.dp__calendar_header_item {
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			letter-spacing: -0.24px;
			text-align: center;
			vertical-align: middle;
			color: var(--color-neutral-500) !important;
		}
		.dp__calendar_header_separator {
			display: none;
		}
		.dp__month_year_select {
			font-weight: 600;
			font-size: 16px;
			line-height: 20px;
			letter-spacing: -0.41px;
			text-align: center;
			vertical-align: middle;
		}
	}
</style>
